import { HttpErrorResponse } from "@angular/common/http";
import { IFirmConsultResponse, ISearchFirm, IValidateFirmIdsResponse } from "../../interfaces/firm.interface";

const ActionTypes = {
  GET_FIRM_CONSULT: '[Firm] Get Firm Consult',
  GET_FIRM_CONSULT_SUCCESS: '[Firm] Get Firm Consult Success',
  GET_FIRM_CONSULT_FAIL: '[Firm] Get Firm Consult Fail',
  GET_FIRM_CONSULT_STREAM: '[Firm] Get Firm Consult Stream',

  SEARCH_FIRM: '[Firm] Search Firm',
  SEARCH_FIRM_SUCCESS: '[Firm] Search Firm Success',
  SEARCH_FIRM_FAIL: '[Firm] Search Firm Fail',

  CLEAR_SEARCH_RESULTS: '[Firm] Clear Search Results',

  VALIDATE_FIRM_IDS: '[Firm] Validate Firm IDs',
  VALIDATE_FIRM_IDS_SUCCESS: '[Firm] Validate Firm IDs Success',
  VALIDATE_FIRM_IDS_FAIL: '[Firm] Validate Firm IDs Fail',
  VALIDATE_FIRM_IDS_STREAM: '[Firm] Validate Firm IDs Stream',

  RESET_FIRM_IDS_VALIDATION: '[Firm] Reset Firm IDs Validation',
};

export class GetFirmConsult {
  static type = ActionTypes.GET_FIRM_CONSULT;

  constructor(public payload: {firmId: string, firmWithAnnualAccounts: boolean}) {}
}

export class GetFirmConsultSuccess {
  static type = ActionTypes.GET_FIRM_CONSULT_SUCCESS;

  constructor(public payload: IFirmConsultResponse, public metadata: string) {}
}

export class GetFirmConsultFail {
  static type = ActionTypes.GET_FIRM_CONSULT_FAIL;

  constructor(public payload: HttpErrorResponse) {}
}

export class GetFirmConsultStream {
  static type = ActionTypes.GET_FIRM_CONSULT_STREAM;

  constructor(public payload: {hash: string, firm: string}) {}
}

export class SearchFirm {
  static type = ActionTypes.SEARCH_FIRM;

  constructor(public payload: string) {}
}

export class SearchFirmNextPage {
  static type = '[Firm] Search Firm Next Page';
}

export class SearchFirmSuccess {
  static type = ActionTypes.SEARCH_FIRM_SUCCESS;

  constructor(public payload: ISearchFirm, public metadata: boolean = false) {}
}

export class SearchFirmFail {
  static type = ActionTypes.SEARCH_FIRM_FAIL;
}

export class ClearSearchResults {
  static type = ActionTypes.CLEAR_SEARCH_RESULTS;
}

export class ValidateFirmIds {
  static type = ActionTypes.VALIDATE_FIRM_IDS;

  constructor(public payload: string[]) {}
}

export class ValidateFirmIdsSuccess {
  static type = ActionTypes.VALIDATE_FIRM_IDS_SUCCESS;

  constructor(public payload: IValidateFirmIdsResponse) {}
}

export class ValidateFirmIdsFail {
  static type = ActionTypes.VALIDATE_FIRM_IDS_FAIL;
}

export class ValidateFirmIdsStream {
  static type = ActionTypes.VALIDATE_FIRM_IDS_STREAM;

  constructor(public payload: string) {}
}

export class ResetFirmIdsValidation {
  static type = ActionTypes.RESET_FIRM_IDS_VALIDATION;
}